import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Copy } from "lucide-react";
import { useToast } from "@/lib/toast";
import { scriptsParaRamo } from "@/lib/scripts";
import { LoadingState } from "@/components/common/States";

/** Scripts aplicaveis ao ramo do lead, especifico-antes-de-generico (RPC
 * scripts_para_ramo, ver comentario na migration). Leitura + "copiar" —
 * CRUD completo fica na tela dedicada /scripts. */
export function ScriptsSugeridos({ ramo }: { ramo: string | null }) {
  const { showToast } = useToast();
  const scriptsQuery = useQuery({
    queryKey: ["scriptsParaRamo", ramo],
    queryFn: () => scriptsParaRamo(ramo),
  });

  async function copiar(texto: string, titulo: string) {
    try {
      await navigator.clipboard.writeText(texto);
      showToast({ message: `"${titulo}" copiado.`, tone: "success" });
    } catch {
      showToast({ message: "Não foi possível copiar — copie manualmente.", tone: "error" });
    }
  }

  if (scriptsQuery.isLoading) return <LoadingState label="Carregando scripts…" />;
  if (scriptsQuery.data?.length === 0) {
    return (
      <p className="field-hint">
        Nenhum script cadastrado ainda para este ramo. Cadastre em <strong>Scripts</strong>.
      </p>
    );
  }

  return (
    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
      {scriptsQuery.data?.map((s) => (
        <ScriptItem key={s.id} titulo={s.titulo} conteudo={s.conteudo} onCopiar={copiar} />
      ))}
    </ul>
  );
}

function ScriptItem({
  titulo,
  conteudo,
  onCopiar,
}: {
  titulo: string;
  conteudo: string;
  onCopiar: (texto: string, titulo: string) => void;
}) {
  const [aberto, setAberto] = useState(false);
  return (
    <li className="card" style={{ marginBottom: 8 }}>
      <div className="utility-row" style={{ marginBottom: aberto ? 8 : 0 }}>
        <button
          type="button"
          className="table-row-button"
          style={{ fontWeight: 600, flex: 1, textAlign: "left" }}
          onClick={() => setAberto((v) => !v)}
          aria-expanded={aberto}
        >
          {titulo}
        </button>
        <button
          type="button"
          className="btn btn--ghost btn--sm"
          onClick={() => onCopiar(conteudo, titulo)}
        >
          <Copy className="icon" size={14} aria-hidden="true" />
          Copiar
        </button>
      </div>
      {aberto && <p style={{ whiteSpace: "pre-wrap", margin: 0 }}>{conteudo}</p>}
    </li>
  );
}
